import React, { useEffect } from 'react'
import { gsap, Power3 } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

const Teenager: React.FC = () => {
	// useEffect(() => {
	// 	gsap.registerPlugin(ScrollToPlugin)

	// 	const text = document.querySelector('.timeline--button__text-p') as HTMLParagraphElement
	// 	text.innerHTML = text.innerText
	// 		.split('')
	// 		.map((char, i) => `<span style="transform:rotate(${i * 5}deg)">${char}</span>`)
	// 		.join('')
	// }, [])

	// const specAnim = () => {
	// 	gsap.context(() => {
	// 		const master = gsap.timeline({ paused: true })

	// 		let container = document.querySelector('.timeline--container') as HTMLDivElement

	// 		master
	// 			.to(window, {
	// 				duration: 0.7,
	// 				ease: Power3.easeIn,
	// 				scrollTo: container,
	// 			})
	// 			.to(container, {
	// 				xPercent: -100 / 6,
	// 			})
	// 			.play()
	// 	})
	// }

	return (
		<div className='timeline--teenager timeline-section'>
			<div className='timeline--teenager__progression'>
				<h3>A progression of Life; A journey of Faith!</h3>
				<p>Different phases, different landmarks but God kept leading and growing her for a generation.</p>
			</div>

			<div className='timeline--teenager__event'>
				<div className='teenager--gallery'>
					<img src='/images/timeline/teenager.png' alt='Mummy Lillian as a teenager' />
					<img src='/images/timeline/portrait.png' alt='Portrait of Mummy Lillian' />
				</div>

				<div className='teenager--content'>
					<h5>A teenager!</h5>
					<p>She had a deep seated desire within her for that which she did not yet know.</p>
					<svg width='216' height='33' viewBox='0 0 216 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M3.99994 8.46405C38.9533 6.15486 28.4479 7.48704 51.2669 5.18349C74.086 2.87993 320.139 4.00081 134.286 8.6802C-51.5679 13.3596 178.35 15.722 198.214 23.4189C202.829 25.2069 207.446 27.5079 212.206 29.0453'
							stroke='#DF5A33'
							strokeWidth='6.36225'
							strokeLinecap='round'
						/>
					</svg>
				</div>
			</div>

			{/* <div className='timeline--button' onClick={() => console.log('here')}>
				<svg width='53' height='53' viewBox='0 0 53 53' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M11.042 26.5H41.9587M41.9587 26.5L26.5003 11.0417M41.9587 26.5L26.5003 41.9584'
						stroke='#101828'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>

				<div className='timeline--button__text'>
					<p className='timeline--button__text-p'>Keep - scrolling - to - learn - about - mummy -</p>
				</div>
			</div> */}
		</div>
	)
}

export default Teenager
